/**
 * Created by Shikha on 2021-12-29.
 */
import {Karen} from "../Karen";
import {KarenLayers, Layers} from "./KarenLayers";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {KarenGameConfig} from "../KarenGameConfig";
import {TimelineLite} from "gsap";
import {SpinePlayer} from "../../core/displayObject/SpinePlayer";
import {GameHelper} from "../../core/utils/GameHelper";
import {ScatterAnimation} from "./ScatterAnimation";

export class KarenStickyXWView extends PIXI.Container {
    private _stickySpines: PIXI.Container[];

    constructor() {
        super();
        this.init();
    }

    public moveStickyXW(reelId: number, scatterPos: number): void {
        if (scatterPos > -1) {
            let toPosition: number = KarenLayers.getLayer(Layers.LOW_SYMBOLS)!.getChildAt(reelId).y + Karen.reels[reelId].getSymbol(scatterPos).y;
            if(Karen.reels[reelId].getSymbol(scatterPos)!.symbolName==="S"){
                Karen.reels[reelId].replaceSimpleSymbol(scatterPos,"L1");
            }
            this._stickySpines[reelId].visible = true;
            this._stickySpines[reelId].y = toPosition;
            this.applyTintFrame(reelId, false);
            this.resettingForFirstSpin(reelId, scatterPos);
        }
    }

    public resettingForFirstSpin(reelId: number, scatterPos: number) {
        const spinePlayer = this._stickySpines[reelId].getChildByName("spineAsset") as SpinePlayer;
        spinePlayer.visible = true;
        if (Karen.model.parsedGameData) {
            if (GameHelper.isFreeSpinTrigger(Karen.model.parsedGameData.mode, Karen.model.parsedGameData.nextMode)) {
                spinePlayer.changeSpine("stickyXWay2");
                ( spinePlayer )!.play({name: "nowin", showOnEnd: true});
                const scattr: ScatterAnimation = new ScatterAnimation("scatter");
                scattr.playTurnToBurgerAnimation();

            }
        }
        if (Karen.model.isRestore) {
            let xWaySize = parseInt(Karen.background.getXWaySize());
            if (xWaySize > 5) {
                xWaySize = 5;
            }
            spinePlayer.changeSpine("stickyXWay" + xWaySize);
        }
    }

    public updateOnUpgrade(index: number): void {
        const tl: TimelineLite = new TimelineLite();
        this._stickySpines[index].visible = true;
        this.applyTintFrame(index, false);
        this._stickySpines[index].getChildByName("spineAsset").visible = true;
        tl.to(this._stickySpines[index], 0.05, {y: this._stickySpines[index].y - ( KarenGameConfig.SYM_HEIGHT[index] ) / 2});
    }

    public hideStickyXW(index: number, scatterPos: number): void {
        if (scatterPos > -1) {
            this._stickySpines[index].getChildByName("spineAsset").visible = false;
        }
    }

    public hideAllStickyXW(): void {
        this._stickySpines.forEach((container: PIXI.Container) => {
            container.visible = false;
        });
    }

    public dimStickyBorder(reelId: number, scatterPos: number): void {
        if (scatterPos > -1) {
            this.applyTintFrame(reelId, true);
        }
    }

    public showStickyXW(reelId: number, xWaySize: number): void {
        this._stickySpines[reelId].visible = true;
        xWaySize=xWaySize>5?5:xWaySize;
        this.updateStickyXWay(xWaySize);
    }

    public playRevealAnimation(reeIndex: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._stickySpines[reeIndex].visible = true;
        }, 0.001);
        tl.add(() => {
            ( this._stickySpines[reeIndex].getChildByName("spineAsset") as SpinePlayer )!.play({name: "reveal"});
        });
        tl.add(() => {
        }, this.fetchDuration("reveal"));
        return tl;
    }

    public playStickyBurgerWinAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({paused: false});
        this._stickySpines.forEach((container: PIXI.Container) => {
            tl.add(( container.getChildByName("spineAsset") as SpinePlayer )!.play({
                name: "x_up",
                showOnEnd: true
            }), 0.01);
        });
        tl.add(() => {
            let xWaySize = parseInt(Karen.background.getXWaySize());
            if (xWaySize > 5) {
                xWaySize = 5;
            }
            this.updateStickyXWay(xWaySize);
        }, this.fetchDuration("x_up"));
        return tl;
    }

    public playStickyBurgerNoWinAnimation(toShowAtEnd: boolean = true): TimelineLite {
        const tl: TimelineLite = new TimelineLite({paused: false});
        this._stickySpines.forEach((container: PIXI.Container) => {
            tl.add(( container.getChildByName("spineAsset") as SpinePlayer )!.play({
                name: "nowin",
                showOnEnd: toShowAtEnd
            }), 0.01);
        });
        tl.add(() => {
            let xWaySize = parseInt(Karen.background.getXWaySize());
            if (xWaySize > 5) {
                xWaySize = 5;
            }
            this.updateStickyXWay(xWaySize);
        }, this.fetchDuration("nowin"));
        return tl;
    }

    public playStickyBurgerNoWinOnReelId(reelId: number): TimelineLite {
        this._stickySpines[reelId].visible = true;
        this.moveStickyXW(reelId, Karen.model.parsedGameData!.scatterPositions![reelId]);
        const tl: TimelineLite = new TimelineLite({paused: false});
        tl.add(( this._stickySpines[reelId].getChildByName("spineAsset") as SpinePlayer )!.play({
            name: "nowin",
            showOnEnd: true
        }), 0.01);
        tl.add(() => {
            let xWaySize = parseInt(Karen.background.getXWaySize());
            if (xWaySize > 5) {
                xWaySize = 5;
            }
            this.updateStickyXWay(xWaySize);
        }, this.fetchDuration("nowin"));
        return tl;
    }

    public fetchDuration(animation: string): number {
        const spinePlayer: SpinePlayer = this._stickySpines[0].getChildByName("spineAsset") as SpinePlayer;
        return spinePlayer.fetchDuration(animation);
    }

    public updateStickyXWay(multiplier: number) {
        this._stickySpines.forEach((container: PIXI.Container) => {
            ( container.getChildByName("spineAsset") as SpinePlayer ).changeSpine("stickyXWay" + ( multiplier ));
        });
    }

    private init(): void {
        this._stickySpines = ArrayHelper.initArrayWithValues(6, () => this.createStickySpine());
        this._stickySpines.forEach((container: PIXI.Container, reeIndex: number) => {
            KarenLayers.getLayer(Layers.STICKY_LAYER)?.addChild(container);
            container.position.set(KarenGameConfig.SYM_WIDTH * reeIndex + KarenGameConfig.SYM_WIDTH / 2, 360);
            container.visible = false;
        });
    }

    private createStickySpine(): PIXI.Container {
        const spineAsset: SpinePlayer = new SpinePlayer("stickyXWay2");
        spineAsset.name = "spineAsset";
        const frame: PIXI.Sprite = new PIXI.Sprite(Karen.assetLoader.getTextures("StickyFrame")[0]);
        frame.name = "frame";
        const container: PIXI.Container = new PIXI.Container();
        frame.anchor.set(0.5);
        container.addChild(spineAsset);
        container.addChild(frame);
        return container;
    }

    private applyTintFrame(reelId: number, tint: boolean): void {
        ( this._stickySpines[reelId].getChildByName("frame")! as PIXI.Sprite ).tint = tint ? 0x555555 : 0xffffff;
    }
}